import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api/api';

/**
 * Protege rutas que requieren autenticación y opcionalmente un rol específico.
 * - Sin sesión → redirige a /login
 * - Con sesión pero rol insuficiente → redirige a /
 *
 * La sesión real se valida en el backend mediante una cookie HttpOnly;
 * aquí solo mantenemos un reflejo local del rol para decidir navegación.
 */
const PrivateRoute = ({ element, allowedRoles }) => {
  const [status, setStatus] = useState('loading'); // 'loading' | 'ok' | 'unauthorized' | 'no_session'

  useEffect(() => {
    let cancelled = false;

    const checkSession = async () => {
      try {
        // El backend lee la cookie HttpOnly; si es válida devuelve { id }
        await api.get('/me');
        if (!cancelled) setStatus('ok');
      } catch (err) {
        if (!cancelled) {
          if (err.response?.status === 401 || err.response?.status === 403) {
            setStatus('no_session');
          } else {
            setStatus('no_session');
          }
        }
      }
    };

    checkSession();
    return () => { cancelled = true; };
  }, []);

  const storedRole = (() => {
    try {
      const stored = localStorage.getItem('currentUser');
      return stored ? JSON.parse(stored).role?.toLowerCase() : null;
    } catch {
      return null;
    }
  })();

  if (status === 'loading') {
    return null; // o un spinner mínimo
  }

  if (status === 'no_session') {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(storedRole)) {
    return <Navigate to="/" replace />;
  }

  return element;
};

export default PrivateRoute;
